define('commons/draggable-elements',['jquery'], function($) {
    /**
     * Adds the drag n drop feature to a given set of dragSources / dragTargets.
     * Sources and targets can be the same set of elements.
     */
    var DraggableElements = function( $dragSources, $dragTargets, customOptions) {

        // Default values
        this.options = {
            /**
             * Drag n drop data mime type. Use 'Text' to be compatible with ... IE 10 ! yes !! 10 and still hacking this sh*t !!!
             */
            mimeType: "Text",

            /**
             * A function to be applied to drag n drop html elements
             */
            getDataTransferObject: function($element, isDropEvent) {
                return null;
            },

            /**
             * Callback called when the drag n drop is complete.
             * 
             * @param dragStartObject :
             *            Result of getDataTransferObject(sourceElement)
             * @param dragEndObject :
             *            Result of getDataTransferObject(destElement)
             * @param onLeftSide :
             *            true if the drop has been done on the left side of the destElement, false otherwise.
             */
            dataDropped: function(dragStartObject, dragEndObject, onLeftSide) {},
            
            handleDragEnter : function(event){},
            
            handleDragStart : function(context, $element){},
            
            handleDragOver : function(context, $element, onLeftSide){},
            
            handleDragLeave : function(context, $element){},
            
            handleDragEnd : function(context, $element){}
        };
        // Extends options
        $.extend(this.options, customOptions);

        this.dragSrc = null;
        this.dragOver = null;
        // Object : { left : bounds.left, halfSize : bounds.width / 2, onLeftSide : true};
        this.dragOverContext = {};

        // The global sources/targets
        this.$dragTargets = $dragTargets;
        this.$dragSources = $dragSources;

        this.CONSTANTS = (function() {
            var privateConstants = {
                'DRAGGING_CLASS': 'dragging',
            };

            return {
                get: function(name) {
                    return privateConstants[name];
                }
            };
        })();

        this._initBindings();
    };

    DraggableElements.prototype._initBindings = function() {
        var here = this;

        this.$dragSources.on('dragstart', this._handleDragStart(here)).on('dragend', this._handleDragEnd(here));
        this.$dragTargets.on('dragenter', this._handleDragEnter(here)).on('dragover', this._handleDragOver(here))
                         .on('dragleave', this._handleDragLeave(here)).on('drop', this._handleDrop(here));
    };

    DraggableElements.prototype._handleDragStart = function(context) {
        return function(e) {
            context.dragSrc = this;
            var $element = $(this);

            $element.addClass(context.CONSTANTS.get('DRAGGING_CLASS'));
            context.options.handleDragStart(context, $element);

            e.originalEvent.dataTransfer.effectAllowed = 'move';
            e.originalEvent.dataTransfer.setData(context.options.mimeType, context.options.getDataTransferObject($element, false));
        };
    };

    DraggableElements.prototype._handleDragEnter = function(context) {
        return function(e) {
            if (this != context.dragSrc && (!context.dragOver || context.dragOver != this)) {
                context.dragOver = this;
                var bounds = this.getBoundingClientRect();
                context.dragOverContext = {
                    left: bounds.left,
                    halfSize: bounds.width / 2
                };

                // this / e.target is the current hover target.
                context.options.handleDragEnter(e);
            }
            return false;
        };
    };

    DraggableElements.prototype._handleDragOver = function(context) {
        return function(e) {
            if (context.dragOver) {
                var clientX = e.originalEvent.clientX;
                var onLeftSide = clientX <= context.dragOverContext.left + context.dragOverContext.halfSize;

                // Perform heavy stuff only if the client has moved left<->right
                if (context.dragOverContext.onLeftSide != onLeftSide) {
                    context.dragOverContext.onLeftSide = onLeftSide;
                    var $elem = $(this);
                    context.options.handleDragOver(context, $elem, onLeftSide);
                }
            }
            return false;
        };
    };

    DraggableElements.prototype._handleDragLeave = function(context) {
        return function(e) {
            if (context.dragOver != this) {
                // this/e.target is the source node.
                context.options.handleDragLeave(context, $(this));
            }
            return false;
        };
    };

    DraggableElements.prototype._handleDrop = function(context) {
        return function(e) {
            // this / e.target is current target element.

            if (e.stopPropagation) {
                e.stopPropagation(); // stops the browser from redirecting.
            }

            // Don't do anything if dropping the same column we're dragging.
            if (context.dragSrc != this) {
                context.options.dataDropped(e.originalEvent.dataTransfer.getData(context.options.mimeType), 
                                            context.options.getDataTransferObject($(e.target), true), 
                                            context.dragOverContext.onLeftSide);
            }
            return false;
        };
    };

    DraggableElements.prototype._handleDragEnd = function(context) {
        return function(e) {
            // this/e.target is the source node
            context.dragSrc = null;
            context.dragOver = null;
            // Object :  { left : bounds.left, halfSize : bounds.width / 2, onLeftSide : true};
            context.dragOverContext = {};
            context.options.handleDragEnd(context, $(this));
           
            return false;
        };
    };
    return DraggableElements;
});
